import React from "react";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { cleanString } from "components/utils/cleanString";
import { toastError } from "components/utils/toasts";

// Alta de un equipo en el torneo. Se busca por nombre entre los equipos del padrón
// y, al aceptar, se verifica que no esté ya en la lista del torneo (por id o por
// nombre) antes de devolverlo con onAccept.
export default function AgregarEquipoModal({ isOpen, teams, equipos, onAccept, onClose }) {
  const [seleccionado, setSeleccionado] = React.useState(null);

  // Cada vez que se abre arranca vacío.
  React.useEffect(() => {
    if (isOpen) setSeleccionado(null);
  }, [isOpen]);

  const aceptar = () => {
    if (!seleccionado) return;

    const nombre = cleanString(seleccionado.label);
    const yaEsta = teams.some((t) => t.id === seleccionado.value || cleanString(t.name) === nombre);
    if (yaEsta) {
      toastError(seleccionado.label + " ya está en el torneo", 2500);
      return;
    }

    onAccept(seleccionado);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Agregar Equipo</ModalHeader>
      <ModalBody>
        <div className="form-group mb-0">
          <label className="font-weight-bold" style={{ fontSize: "0.8125rem" }}>
            Nombre del equipo
          </label>
          <Select
            autoFocus
            isSearchable={true}
            placeholder="Buscá un equipo..."
            classNamePrefix="react-select"
            name="selectedTeam"
            value={seleccionado}
            onChange={setSeleccionado}
            options={equipos}
            noOptionsMessage={() => "Sin equipos disponibles"}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 2000 }) }}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="btn-arhock btn-sm my-0" style={{ opacity: 0.55 }} onClick={onClose}>
          Cancelar
        </Button>
        <Button className="btn-arhock btn-sm my-0" onClick={aceptar} disabled={!seleccionado}>
          Aceptar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
